const Footer = () => (
  <footer className="flex justify-center flex flex-col gap-2 sm:flex-row py-6 w-full shrink-0 items-center px-4 md:px-6 border-t bg-black">
    <p className="text-xs text-gray-500 dark:text-gray-400 white">
      © 2024 Cloudfull. All rights reserved.
    </p>
  </footer>
);

export default Footer;
